import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient"
import { PaginationResponse, ResponseData } from "./types/_public";
import { IFacility } from "./types/_facility";

const api = new APIClient();

const path = '/staffs';

const staffApi = {
  staffs(params: any): Promise<AxiosResponse<ResponseData<IFacility[]> & PaginationResponse, any>> {
    const url = `${path}`
    return api.get(url, params)
  },

  bartenderNoBar(params: any): Promise<any> {
    const url = `${path}/available`
    return api.get(url, params)
  },

  getStaff(id: string | number, params: any = {}) : Promise<AxiosResponse<ResponseData<IFacility>, any>>  {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },
  
  deleteStaff(id: any) {
    return api.delete(`${path}/${id}`);
  },
  
  postStaff(dataForm: any) : Promise<AxiosResponse<ResponseData<IFacility>, any>>  {
    const url = `${path}`;
    return api.post(url, dataForm)
  },

  putStaff(id: string | number, dataForm: any) : Promise<AxiosResponse<ResponseData<IFacility>, any>>  {
    const url = `${path}/${id}`;
    return api.put(url, dataForm)
  },
  
}

export default staffApi
